import { createSelector } from 'reselect';
// Import state types.
import {
	NewBusinessApplicationState,
} from '@app/redux/states';
// Import api models.
import {
	BindingAuthorityEligibilityResult,
} from '@app/models/api';
// Import base selectors.
import {
	getNewBusinessApplicationState,
} from '@app/redux/selectors/base';

// Get Binding Authority Eligibility Results Selector.
const makeGetBindingAuthorityEligibilityResultsSelector = () => createSelector(
	[getNewBusinessApplicationState],
	(newBusinessApplicationState: NewBusinessApplicationState | undefined): BindingAuthorityEligibilityResult[] => {
		return newBusinessApplicationState?.bindingAuthorityEligibilityResults ?? [];
	}
);

// Are Binding Authority Eligibility Results Loaded Selector.
const makeAreBindingAuthorityEligibilityResultsLoadedSelector = () => createSelector(
	[getNewBusinessApplicationState],
	(newBusinessApplicationState: NewBusinessApplicationState | undefined): boolean => {
		return newBusinessApplicationState?.areBindingAuthorityEligibilityResultsLoaded ?? false;
	}
);

// Get Binding Authority Eligibility Results Count Selector.
const makeGetBindingAuthorityEligibilityResultsCountSelector = () => createSelector(
	[makeGetBindingAuthorityEligibilityResultsSelector()],
	(bindingAuthorityEligibilityResults: BindingAuthorityEligibilityResult[]): number => {
		return bindingAuthorityEligibilityResults.length;
	}
);

// export selectors.
export {
	makeGetBindingAuthorityEligibilityResultsSelector,
	makeAreBindingAuthorityEligibilityResultsLoadedSelector,
	makeGetBindingAuthorityEligibilityResultsCountSelector,
};